import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const InfoCircleIcon = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 23 22",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.5 11.004C22.5 17.017 17.517 22 11.496 22 5.483 22 .5 17.017.5 11.004.5 4.983 5.474 0 11.487 0 17.51 0 22.5 4.983 22.5 11.004ZM8.81 16.52c0 .397.304.692.71.692h4.552c.405 0 .717-.295.717-.692 0-.38-.312-.684-.717-.684H12.56v-6.03c0-.507-.262-.861-.752-.861H9.68a.692.692 0 0 0-.71.684c0 .396.313.692.71.692h1.351v5.515H9.52c-.406 0-.71.304-.71.684Zm1.292-10.86c0 .734.583 1.325 1.318 1.325.735 0 1.309-.59 1.309-1.326 0-.734-.574-1.326-1.31-1.326-.734 0-1.317.592-1.317 1.326Z",
    clipRule: "evenodd"
  })
});
export default InfoCircleIcon;